import React, { useState, useEffect, useRef, useContext } from 'react'
import { NavLink, Link, useLocation } from 'react-router-dom'
import './menus.css'
import logo from '../../assets/images/anew-logo.svg'
import { UserContext } from '../../store/contexts/UserContextProvider'
import { DeviceDetailsContext } from '../../store/contexts/UserDeviceContextProvider'
import { isProcessorDisabled } from '../../Configuration'

const COLLAPSE_MENU_EVENT = 'collapse-side-menu'
const EXPAND_MENU_EVENT = 'expand-side-menu'

export default function Menus() {
  const [isOpen, setIsOpen] = useState(() => window.innerWidth > 1400)
  const {isUserDetailsLoading,userRoles}=useContext(UserContext)
  const {isMobile,isWeb}=useContext(DeviceDetailsContext)
  const [roleBasedMenuItem, setRoleBasedMenuItem] = useState<any>()
  const toggle = () => {
    setIsOpen((prevIsOpen) => {
      const nextIsOpen = !prevIsOpen

      if (nextIsOpen) {
        window.dispatchEvent(new CustomEvent(EXPAND_MENU_EVENT))
      }

      return nextIsOpen
    })
  }
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const location = useLocation()
  const { pathname } = location
  const splitLocation = pathname.split('/')
  const [isMobileApp, setIsMobileApp] = useState(false)
  const [isMobileMenu, setIsMobileMenu] = useState(false)
  const menuRef = useRef<HTMLDivElement | null>(null)
  const menuListRef = useRef<HTMLUListElement | null>(null)

  const toggleMenu = () => {
    setIsMobileMenu(true)
  }
  useEffect(() => {
    const nextIsMobileApp = windowSize.innerWidth < 1024

    if (nextIsMobileApp) {
      setIsOpen(false)
      setIsMobileApp(true)
    } else {
      setIsMobileApp(false)
    }
    let listItems = roleBasedMenuItem
       setRoleBasedMenuItem(listItems)
  }, [windowSize])

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(prev => {
        const newSize = getWindowSize()
        return prev.innerWidth !== newSize.innerWidth ? newSize : prev
      })
    }
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        if (isMobileApp && isMobileMenu) {
          setIsMobileMenu(false)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMobileApp, isMobileMenu])
  useEffect(() => {
    const handleCollapseMenu = () => {
        if (window.innerWidth < 1024) {
            setIsMobileMenu(false);
            return;
        }

        setIsOpen(false);
    };

    window.addEventListener(COLLAPSE_MENU_EVENT, handleCollapseMenu);

    return () => {
        window.removeEventListener(COLLAPSE_MENU_EVENT, handleCollapseMenu);
    };
}, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }
  const isactivepathProcessor = !(userRoles.isCustomer || userRoles.isTRMInbound || userRoles.isTRMOutbound || userRoles.isTRMSales || userRoles.isTRMSuperAdmin || userRoles.isTRMAdmin) && userRoles?.isTRMProcessor ? ['/','workorders-detailview'] :['/']
  const menuitem = [
    {
      path: '/',
      activepath: isactivepathProcessor,
      name: isMobileApp || (userRoles.isTRMProcessor && !isProcessorDisabled) ? 'Home' : 'Dashboard',
      icon: isMobileApp || (userRoles.isTRMProcessor && !isProcessorDisabled) ? 'icon-home-app' : 'icon-dashboard-menu'
    },
    {
      path: '/create-inquiry',
      activepath: ['create-inquiry'],
      name: 'Create Inquiry',
      icon: 'icon-create-inquiry-menu',
    },
    {
      path: '/inquiries',
      activepath: ['inquiries', 'inquiries-detailview'],
      name: 'Inquiries',
      icon: 'icon-inquires-menu',
    },
    {
      path: '/work-orders',
      activepath: ['work-orders','workorders-detailview'],
      name: 'Work Orders',
      icon: 'icon-work-orders-menu',
    },
    {
      path:'/reports-data',
      activepath:['reports-data'],
      name:'Reports Data',
      icon:'icon-reports-data'
    },
    {
      path: '/archived',
      activepath: ['archived'],
      name: 'Archived',
      icon: 'icon-archived',
    },
    {
      path: '/import-data',
      activepath: ['import-data'],
      name: 'Import Data',
      icon: 'icon-import-data',
    },   
    {
      path: '/renewals',
      activepath: ['renewals'],
      name: 'Renewals',
      icon: 'icon-renewals',
    },
    {
      path: '/knowledge-graph',
      activepath: ['knowledge-graph'],
      name: 'Knowledge Graph',
      icon: 'icon-rb-book-open',
    },
    {
      path: '/qanda',
      activepath: ['qanda'],
      name: 'Q&A',
      icon: 'icon-rb-question-thick',
    },
    {
      path: '/announcements',
      activepath: ['announcements'],
      name: 'Announcements',
      icon: 'icon-rb-announcement-mic',
    },
    {
      path: '/calendars',
      activepath: ['calendars'],
      name: 'Calendar',
      icon: 'icon-rb-calendar-days',
    },
    {
      path: '/master-activity-log',
      activepath: ['master-activity-log'],
      name: 'Master Activity Log',
      icon: 'icon-rb-arrow-anticlockwise-timer',
    },  
    {
      path: '/settings',
      activepath: ['settings'],
      name: 'Settings',
      icon: 'icon-manage-checklist',
    },
    {
      path: '/site-feedback',
      activepath: ['site-feedback'],
      name: 'Site Feedback',
      icon: 'icon-site-feedback',
    },
     {
      path: '/Release-Notes',
      activepath: ['Release-Notes'],
      name: 'Release Notes',
      icon: 'icon-release-notes',
    }
  ]

useEffect(() => {
 const { isTRMAdmin, isTRMInbound, isTRMOutbound, isTRMSales, isTRMProcessor ,isTRMSuperAdmin,isCustomer} = userRoles;
  if ((isUserDetailsLoading || !userRoles)) return;
  let excludePaths:string[] =[]
  const mobileOnlyExcludedPaths = isMobileApp ? ['/import-data'] : []
  if(!(isTRMAdmin || isTRMSuperAdmin)){
  if (isCustomer) {
    excludePaths = ['/settings', '/master-activity-log', '/calendars', '/announcements', '/archived', '/import-data', '/renewals','/reports-data',];
  } else if (isTRMInbound) {
    excludePaths = ['/master-activity-log', '/import-data','/reports-data'];
  } else if (isTRMOutbound || isTRMSales) {
    excludePaths = ['/settings', '/master-activity-log', '/import-data','/reports-data'];
  } else if (isTRMProcessor) {
    excludePaths = ['/create-inquiry', '/inquiries', '/settings', '/master-activity-log', '/calendars', '/announcements', '/work-orders', '/customer-login', '/archived', '/import-data', '/renewals','/reports-data'];
  }
  
}
    const listItems = [...menuitem].filter(item => !excludePaths.includes(item.path) && !mobileOnlyExcludedPaths.includes(item.path));
  setRoleBasedMenuItem(listItems);
}, [isUserDetailsLoading, userRoles, isMobileApp]);

// useEffect(()=>{
//   let listItems = roleBasedMenuItem
//    setRoleBasedMenuItem(listItems)
// },[location.pathname,windowSize.innerHeight,windowSize.innerWidth])
 
  function activeClass(item: { path: string; activepath?: { toString: () => string; }[]; }) {
    const prevPath = (location as any)?.state?.previouspath
    const isDetailRoute = pathname.includes('detailview')
    const fromSearch = (location as any)?.state?.fromSearch

    if (isDetailRoute && fromSearch) {
      const detailSegment = splitLocation[1]
      if (item?.activepath) {
        return item?.activepath.some((element: any) => element === detailSegment)
      }
      return false
    }

    if (isDetailRoute && prevPath) {
      return prevPath === item.path
    }

    let ischecked = false
    if (item?.activepath) {
      item?.activepath.forEach(element => {
        if (splitLocation[1] === item.path || splitLocation[1] === element) {
          ischecked = true
        }
      })
      return ischecked
    }
    return false
  }
  const handleMobileNavClose = () => {
    if (isMobileApp) {
      setIsMobileMenu(false)
    }
  }
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        isMobileApp &&
        isMobileMenu &&
        menuListRef.current &&
        !menuListRef.current.contains(event.target as Node)
      ) {
        setIsMobileMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMobileApp, isMobileMenu])
  return (

    <div ref={menuRef} className={`menus ${isOpen ? 'menuexpand' : 'menucollapsed'}`}>
      {/* <div  ref={menuRef} className={`${isMobileApp ? '':'menus'} ${isOpen ? 'menuexpand' : 'menucollapsed'}`}> */}
      <div className='container'>
        <div className='sidebar'>
          <nav className={`${isMobileApp ? (isMobileMenu ? 'mobile-nav mobile-nav-expand' : 'mobile-nav') : ''}`}>
<div className={isMobileApp ? 'app-logo-main' : ''}>
            <div className="logo">
              {/* {isMobileMenu ? 'app-logo bgcolor-6' : 'sidebar-logo'} */}
               {isMobileApp && <div tabIndex={0}  onClick={() => setIsMobileMenu(false)} aria-label='Collapse Menu' role='button' className='text-end w-100'>
                     <span className='icon-rb-arrow-left-thick whitetext'></span>
                 </div>
}
              <Link className="p-0 d-flex align-items-center" title="Anew Title and Registration Management" to="/">
                <img src={logo} fetchPriority="high" loading="eager" alt='Anew Title and Registration Management' title='Anew Title and Registration Management' width={180} height={60} className='w-100' />
                {(isOpen || isMobileMenu) && <p className='logo-title'>Title and Registration Management</p>}
              </Link>
             {!isMobileApp &&  <div tabIndex={0} role="button" title={isOpen ? 'Collapse' : 'Expand'} className={`whitetext toggle-menu icon-side-nav-open text-right p-1`} onClick={toggle} onKeyDown={(event) => { event.key === 'Enter' && toggle() }}></div>}
            </div>
           {isMobileApp && <div className='main-menu-icon'>
            <a className='burger-icon' onClick={toggleMenu} role='button' tabIndex={0} title={isOpen ? 'Collapse' : 'Expand'}>
              <div className={`${isMobileMenu ? '' : 'icon-rb-lines-three font-16'}`}></div>
            </a>
          </div>
}
          </div>
            <ul ref={menuListRef} className={isMobileApp ? 'mobile-nav-items' : ''}>
              {roleBasedMenuItem?.map((item: any, index: number) => (
                <li key={item.name}>
                  <NavLink to={item.path} key={index} onClick={handleMobileNavClose} className={activeClass(item) ? 'link active' : 'link'} title={item.name}>
                    <div className={item.icon}></div>
                    <div className='menuitems font-14 d-flex gap-1 align-items-center w-100'><span>{item.name}</span>{item.submenus && (isOpen ? (<span className={`m-0 font-8 ps-1 ${activeClass(item) ? 'icon-rb-arrow-down-thick' : 'icon-rb-arrow-right-thick'}`}></span>) : (<span className='m-0 font-8 ps-1 icon-rb-arrow-right-thick'></span>))}</div>
                  </NavLink>
                  {/* Render submenus if available */}
                  {item.submenus && (
                    <div className='submenus' style={isOpen ? {} : { top: item.ref?.current?.offsetTop }}>
                      {item.submenus?.map((submenu: any, index: number) => (
                        <NavLink to={submenu.path} key={index} className={activeClass(submenu) ? 'link active' : 'link'} title={submenu.name}>
                          <div className='menuitems'>{submenu.name}</div>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </li>
              ))}              
                <li>
                    <Link to="https://anewtransport.com/privacy-policy" target="_blank" className="menu-separator" title="Privacy Policy">
                      <div className='icon-privacy-policy'></div>
                      <div className='menuitems font-14 d-flex gap-1 align-items-center w-100'>Privacy Policy</div>
                    </Link>
                </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}


